export const apiEndPoints = {
  bulkOrder: {
    getBulkOrderStatusDetails: '/bulk-order/public-status/',
    export: '/bulk-orders/public-status/export/',
  },
};
